import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CreateRideDto } from "./dto/createRideDto";
import { Observable } from "rxjs";
import { RestResponse } from "../../shared/RestResponse";
import { ListRideDto } from "./dto/listRideDto";
import { environment } from "../../../environments/environment";
import { GetRideDto } from "./dto/getRideDto";
import { formatDate } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class RideService {
  private readonly baseUrl = `${environment.base_url}/rides`;

  constructor(private http: HttpClient) {}

  create(dto: CreateRideDto): Observable<RestResponse<void>> {
    return this.http.post<RestResponse<void>>(`${this.baseUrl}/create`, dto);
  }

  list(search: string, driverId: number | null, fromCityId: number | null, toCityId: number | null, status: string | null, startDate: string | null, endDate: string | null, page: number): Observable<RestResponse<ListRideDto[]>> {
    let params: any = { page };
    
    if (search) {
      params.search = search;
    }
    if (driverId) {
      params.driverId = driverId;
    }
    if (fromCityId) {
      params.fromCityId = fromCityId;
    }
    if (toCityId) {
      params.toCityId = toCityId;
    }
    if (status) {
      params.status = status;
    }
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    return this.http.get<RestResponse<ListRideDto[]>>(`${this.baseUrl}/list`, {params});
  }

  update(id: number, dto: CreateRideDto): Observable<RestResponse<CreateRideDto>> {
    return this.http.put<RestResponse<CreateRideDto>>(`${this.baseUrl}/update/${id}`, dto);
  }

  delete(id: number): Observable<RestResponse<void>> {
    return this.http.delete<RestResponse<void>>(`${this.baseUrl}/delete/${id}`);
  }

  getById(id: number): Observable<RestResponse<GetRideDto>> {
    return this.http.get<RestResponse<GetRideDto>>(`${this.baseUrl}/find/${id}`);
  }

  getRideClients(rideId: number): Observable<RestResponse<any[]>> {
    return this.http.get<RestResponse<any[]>>(`${this.baseUrl}/${rideId}/clients`);
  }

  addClientToRide(rideId: number, clientId: number, addressData?: any): Observable<RestResponse<void>> {
    const payload = addressData ? { customerId: clientId, rideId: rideId, fromAddress: addressData.fromAddress, toAddress: addressData.toAddress} : {};
    return this.http.patch<RestResponse<void>>(`${this.baseUrl}/add-customer`, payload);
  }

  removeClientFromRide(rideId: number, clientId: number): Observable<RestResponse<void>> {
    const payload = { customerId: clientId, rideId: rideId};
    return this.http.patch<RestResponse<void>>(`${this.baseUrl}/remove-customer`, payload);
  }
}
